import { Box, Typography, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const RequestsPanel = styled(Box)(() => ({
  background: '#FFF',
  minHeight: '400px',
  maxHeight: '800px',
  borderRadius: '8px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#B9BABB',
    borderRadius: 10,
    '&:hover': {
      backgroundColor: '#B9BABB',
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '40px 0',
  },
}));

export const ItemWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
  padding: '16px',
  cursor: 'pointer',
  borderBottom: '1px solid #D7D8DB',
  '&:last-child': { borderBottom: 'none' },
  borderLeft: isSelected
    ? `3px solid ${theme.palette.primary.main}`
    : '3px solid transparent',
  background: isSelected
    ? alpha(theme.palette.primary.main, 0.06)
    : 'transparent',
  '&:hover': {
    background: isSelected
      ? alpha(theme.palette.primary.main, 0.08)
      : '#F5F5F5',
  },
}));

export const OsRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'top',
  justifyContent: 'space-between',
  marginBottom: '8px',
}));

export const OsNumber = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.primary.dark,
}));

export const StatusBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: 'pending' | 'approved' | 'rejected' }>(({ status }) => {
  const colors = {
    pending: '#A65F00',
    approved: '#266929',
    rejected: '#732828',
  };
  const bgcolors = {
    pending: '#FEF9C2',
    approved: '#ccffcf',
    rejected: '#fdbcbc',
  };
  return {
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 500,
    color: colors[status],
    background: bgcolors[status],
  };
});

export const ClientName = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 500,
  marginBottom: '4px',
}));

export const DetailRow = styled(Typography)(() => ({
  fontSize: '12px',
  lineHeight: 1.6,
  span: {
    fontWeight: 600,
  },
}));

export const CompanyHeader = styled(Box)(() => ({
  padding: '16px',
  borderBottom: '1px solid #D7D8DB',
}));

export const CenteredBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '80px',
}));
